import classNames from 'classnames';

// styles
import s from './Switch.sss';

// types
export type SwitchProps = React.HTMLProps<HTMLInputElement>;

export const Switch: React.FC<SwitchProps> = ({
  className,
  ...props
}) => (
  <label
    className={
      classNames(
        s.switchLabel,
        { [s.disabled]: props.disabled },
        { [s.active]: props.checked },
        className,
      )
    }
    htmlFor={props.name}
  >
    <input
      {...props}
      className={s.switchCheckbox}
      type="checkbox"
      hidden={true}
    />
    <span className={s.switchButton} />
  </label>
);

export default Switch;
